import LayoutView from "../layouts/LayoutView";

const MainIndicators = () => {
  return (
    <LayoutView title={"Indicadores"} link={"staff_supply"}>
      MainIndicators
    </LayoutView>
  );
};

export default MainIndicators;
